import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"

export default class extends Controller {
  static targets = ["table"]

  static values = {
    ajaxUrl: String,
  }

  connect() {
    if (!this.hasTableTarget) return
    this.#initDataTable()
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable = destroyTurboDataTable(this.dataTable)
    }
    const wrapper = document.getElementById("audit_logs_wrapper")
    if (wrapper) {
      $(wrapper).off(".auditLogs")
    }
    $(this.tableTarget).off(".auditLogs")
  }

  #initDataTable() {
    this.dataTable = createTurboDataTable(this.tableTarget, {
      dom: '<"H"lr>t<"F"<"toolbar">ip>',
      scrollX: true,
      bPaginate: true,
      order: [0, "asc"],
      stateSave: true,
      serverSide: true,
      processing: true,
      searchDelay: 2000,
      pagingType: "full_numbers",
      ajax: {
        url: this.ajaxUrlValue,
      },
      columnDefs: [
        {
          targets: [0, 1, 2, 3, 4],
          sortable: false,
        },
      ],
    })
  }
}
